<template>
	<div class="pages-setting">
		<van-nav-bar class="custom-nav-bar" :title="$t('setting.page_title')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>
		<div class="page-content">
			<div class="user-card">
				<div class="user-avatar" @click="openAvatarPopup()">
					<img class="avatar-img" :src="currentAvatar" alt="" />
				</div>
				<div class="user-info">
					<div class="user-name">{{ $t('common.username') }}</div>
					<div class="user-mobile">{{ userInfo.username || '' }}</div>
				</div>
			</div>

			<div class="settings-card">
				<div class="setting-item" @click="toPayPassword()">
					<div class="setting-item__left">
						<div class="setting-item__title">{{ $t('setting.pay_password') }}</div>
						<div class="setting-item__desc">{{ $t('setting.password_protect_desc') }}
						</div>
					</div>
					<div class="setting-item__right">
						<span class="tn-icon-right tn-color-gray"></span>
					</div>
				</div>
				<div class="setting-item" @click="toLoginPassword()">
					<div class="setting-item__left">
						<div class="setting-item__title">{{ $t('auth.login_password') }}</div>
						<div class="setting-item__desc">{{ $t('setting.password_protect_desc') }}
						</div>
					</div>
					<div class="setting-item__right">
						<span class="tn-icon-right tn-color-gray"></span>
					</div>
				</div>
				<div class="setting-item" @click="toServicePage()">
					<div class="setting-item__left">
						<div class="setting-item__title">{{ $t('setting.feedback_question') }}</div>
						<div class="setting-item__desc">{{ $t('setting.feedback_desc') }}</div>
					</div>
					<div class="setting-item__right">
						<span class="tn-icon-right tn-color-gray"></span>
					</div>
				</div>
				<div class="setting-item" @click="toAboutUs()">
					<div class="setting-item__left">
						<div class="setting-item__title">{{ $t('about.title') }}</div>
						<div class="setting-item__desc">{{ $t('about.description') }}</div>
					</div>
					<div class="setting-item__right">
						<span class="tn-icon-right tn-color-gray"></span>
					</div>
				</div>
			</div>

			<div class="logout-section">
				<div class="out-btn" @click="loginout()">{{ $t('common.logout') }}</div>
			</div>
		</div>

		<van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
			<div class="avatar-popup">
				<div class="popup-header">
					<span class="popup-title">{{ $t('setting.choose_avatar') }}</span>
					<span class="popup-close" @click="closeAvatarPopup()">×</span>
				</div>
				<div class="popup-content">
					<div class="item" v-for="avatar in avatarList" :key="avatar">
						<div class="item__box">
							<div class="avatar-option" @click="selectAvatar(avatar)">
								<div class="avatar-option__img" :style="{ backgroundImage: `url(${avatar})` }">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfo: {},
				show: false,
				savingAvatar: false,
				avatarList: Array.from({
					length: 18
				}, (_, index) => `/img/mine/${index + 1}.png`)
			};
		},
		computed: {
			currentAvatar() {
				return this.formatAvatar(this.userInfo.header_img);
			}
		},
		methods: {
			back() {
				return window.history.back();
			},
			openAvatarPopup() {
				this.show = true;
			},
			closeAvatarPopup() {
				this.show = false;
			},
			formatAvatar(path) {
				if (!path) {
					return this.avatarList[0];
				}
				if (/^(https?:)?\/\//.test(path) || path.startsWith('/')) {
					return path;
				}
				return `/${path.replace(/^\/+/, '')}`;
			},
			selectAvatar(avatar) {
				if (this.savingAvatar) {
					return;
				}
				this.savingAvatar = true;
				this.$http({
					method: 'post',
					data: {
						header_img: avatar
					},
					url: 'user_header_img'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo.header_img = avatar;
						this.show = false;
						this.$toast(res.msg);
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				}).finally(() => {
					this.savingAvatar = false;
				});
			},
			toPayPassword() {
				if (this.userInfo.paypassword !== this.$t("setting.no_setting")) {
					this.$toast(this.$t("withdraw.with_service"));
				} else {
					this.$router.push({
						path: '/SetPayPassword'
					});
				}
			},
			toLoginPassword() {
				this.$router.push({
					path: '/SetLoginPassword'
				});
			},
			toAboutUs() {
				this.$router.push({
					path: '/AboutUs'
				});
			},

			toLanguage() {
				this.$router.push({
					name: 'Language',
					params: {
						"type": "setting"
					}
				});
			},
			toInfomation() {
				this.$router.push({
					path: '/Infomation'
				});
			},
			loginout() {
				localStorage.clear()
				this.$router.push({
					path: '/Login'
				});
			},
			toServicePage() {
				const service = this.$store.getters.getBaseInfo || {};
				if (service.iskefu == 1 && service.kefu) {
					window.location.href = service.kefu;
					return;
				}
				this.$toast(this.$t("setting.forbid"));
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						if (res.data.paypassword) {
							this.userInfo.paypassword = this.$t("setting.y_setting");
						} else {
							this.userInfo.paypassword = this.$t("setting.no_setting");
						}
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	/* 页面背景 */
	.pages-setting {
		width: 100%;
		height: 100vh;
		background-color: #f5f5f5;
		padding-bottom: 0;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
	}

	/* 页面内容 */
	.page-content {
		padding: 20px 10px;
	}

	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 202px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px;
	}

	/* 用户信息卡片 */
	.user-card {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		margin-bottom: 12px;
		display: flex;
		align-items: center;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.user-card .user-avatar {
		margin-right: 12px;
		position: relative
	}

	.user-card .user-avatar .avatar-img {
		width: 62px;
		height: 62px;
		border-radius: 50%;
		border: 1px solid #f0f0f0
	}

	.user-card .user-info {
		flex: 1
	}

	.user-card .user-info .user-name {
		font-size: 16px;
		font-weight: 600;
		color: #333;
		margin-bottom: 4px
	}

	.user-card .user-info .user-mobile {
		font-size: 12px;
		color: #666
	}

	/* 设置选项卡片 */
	.settings-card {
		background: #fff;
		border-radius: 8px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
		overflow: hidden
	}

	.settings-card .setting-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px;
		border-bottom: 0.5px solid #f0f0f0;
		transition: all .3s ease
	}

	.settings-card .setting-item:last-child {
		border-bottom: none
	}

	.settings-card .setting-item:active {
		background-color: #f8f9fa
	}

	.settings-card .setting-item__left {
		flex: 1
	}

	.settings-card .setting-item__title {
		font-size: 14px;
		font-weight: 600;
		color: #333;
		margin-bottom: 2px
	}

	.settings-card .setting-item__desc {
		font-size: 11px;
		color: #999
	}

	.settings-card .setting-item__right {
		font-size: 14px
	}

	/* 退出登录按钮 */
	.logout-section {
		margin-top: 20px
	}

	.out-btn {
		color: #fff !important;
		padding: 15px 0px;
		font-size: 14px;
		height: 33px;
		width: 100%;
		background-color: rgb(255, 59, 48);
		box-shadow: rgba(255, 59, 48, 0.063) 3px 3px 4px;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		line-height: 1;
		text-align: center;
		text-decoration: none;
		overflow: visible;
		-webkit-transform: translate(0px, 0px);
		transform: translate(0px, 0px);
		border-radius: 6px;
		margin: 0;
	}

	.out-btn::before {
		content: " ";
		display: block;
		background: inherit;
		-webkit-filter: blur(5px);
		filter: blur(5px);
		position: absolute;
		width: 100%;
		height: 100%;
		top: 5px;
		left: 5px;
		z-index: -1;
		opacity: .4;
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		border-radius: inherit;
		-webkit-transform: scale(1);
		transform: scale(1);
	}

	.out-btn::after {
		content: " ";
		width: 200%;
		height: 200%;
		position: absolute;
		top: 0;
		left: 0;
		border: 1px solid rgba(0, 0, 0, .2);
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		box-sizing: border-box;
		border-radius: 10px;
		border: none;
	}

	/* 头像选择弹窗 */
	.avatar-popup {
		padding: 10px
	}

	.avatar-popup .popup-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
		border-bottom: 0.5px solid #f0f0f0;
		margin-bottom: 10px
	}

	.avatar-popup .popup-header .popup-title {
		font-size: 16px;
		font-weight: 600;
		color: #333
	}

	.avatar-popup .popup-header .popup-close {
		font-size: 20px;
		color: #999;
		line-height: 1;
		padding: 5px;
		cursor: pointer
	}

	.avatar-popup .popup-content {
		width: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
	}

	.avatar-popup .popup-content .item {
		box-sizing: border-box;
		background-color: #fff;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		position: relative;
		flex-direction: column;
		width: 25%;
	}

	.avatar-popup .item__box {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		flex: 1;
		width: 100%;
		height: 100%;
	}

	.avatar-popup .avatar-option {
		width: 100%;
		padding: 5px;
	}

	.avatar-popup .avatar-option__img {
		width: 100%;
		height: 52px;
		border-radius: 6px;
		border: 1px solid transparent;
		transition: all .3s ease;
		display: inline-block;
		overflow: hidden;
		position: relative;
		background-position: center center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	.avatar-popup .avatar-option__img:active {
		border-color: #1f77d5;
		-webkit-transform: scale(.95);
		transform: scale(.95)
	}

	/* 导航栏返回按钮 */
	.tn-custom-nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px
	}

	.tn-custom-nav-bar__back .icon {
		display: block
	}
</style>
